import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const MenuContainer = styled.div`
	min-width: 200px;
	padding: 12px;
	background-color: #41588a;
	border-radius: 0 0 8px 8px;
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
`;

export const StyledUL = styled.ul`
	margin: 0;
	padding: 0;
	list-style: none;

	display: flex;
	flex-direction: column;
	align-items: stretch;
	gap: 4px;
`;

export const StyledLink = styled(Link)`
	color: #c7d4d6;
	text-decoration: none;
	padding: 8px 16px;
	border-radius: 4px;
	display: block;
	transition: background-color 0.2s ease;

	&:hover {
		background-color: rgba(255, 255, 255, 0.1);
	}

	&:active {
		background-color: rgba(255, 255, 255, 0.2);
	}
`;
